import React, { useEffect, useRef, useState } from "react";
import Modal from "../../../../components/ui/Modal";
import { Button } from "../../../../components/ui/button";
import { Textarea } from "../../../../components/ui/Field";
import { useToast } from "../../../../components/ui/toast/ToastProvider";
import { batchApi } from "../../../../api/batchApi";
import { unwrapBatch } from "../../batchAdapters";

const DISPOSITIONS = [{ value: "ok", label: "Mark as OK" }, { value: "rework", label: "Send to Rework" }, { value: "reject", label: "Reject Part" }];

const EditNgPartModal = ({ open, batchUid, batchId, cycle, onClose, onSaved }) => {
  const toast = useToast();
  const [disposition, setDisposition] = useState("");
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const submitting = useRef(false);

  useEffect(() => {
    if (open) { setDisposition(cycle?.disposition || ""); setComment(""); setError(""); }
  }, [open, cycle]);

  const handleSave = async event => {
    event.preventDefault();
    if (submitting.current) return;
    if (!disposition || !comment.trim()) { setError(!disposition ? "Select a disposition for this NG part." : "Add a reason for this disposition."); return; }
    submitting.current = true;
    setIsSaving(true);
    setError("");
    try {
      const response = await batchApi.updateCycle(batchUid, cycle.cycleNo, { disposition, comment: comment.trim() });
      const saved = unwrapBatch(response);
      if (!saved?.cycle_no) throw new Error("The cycle update could not be confirmed. Refresh and try again.");
      onSaved?.(saved);
      toast.success(`${cycle.partId} updated.`);
      onClose();
    } catch (err) { setError(err?.message || "Unable to update this cycle."); }
    finally { submitting.current = false; setIsSaving(false); }
  };

  if (!cycle) return null;
  return (
    <Modal open={open} onClose={() => !submitting.current && onClose()} title="Edit NG Part" description="Update the disposition of this NG cycle and add remarks to document the action taken." size="lg">
      <form onSubmit={handleSave} noValidate>
        <div className="mb-4 flex justify-between text-sm font-semibold text-slate-800"><span>{batchId}</span><span>{cycle.partId}</span></div>
        <fieldset disabled={isSaving}>
          <legend className="sr-only">Cycle disposition</legend>
          <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:justify-between">
            {DISPOSITIONS.map(option => <label key={option.value} className="flex items-center gap-2 text-sm text-slate-700"><input type="radio" name="ng-disposition" value={option.value} checked={disposition === option.value} onChange={event => { setDisposition(event.target.value); setError(""); }} className="h-4 w-4 accent-violet-600" />{option.label}</label>)}
          </div>
          <label htmlFor="cycle-comment" className="mb-1.5 block text-xs font-medium text-slate-600">Add Comment</label>
          <Textarea id="cycle-comment" rows={3} maxLength={2000} required value={comment} onChange={event => { setComment(event.target.value); setError(""); }} placeholder="Add the reason or any additional details for this action..." />
        </fieldset>
        {error && <p role="alert" className="mt-3 text-sm text-rose-600">{error}</p>}
        <div className="mt-5 flex justify-end gap-2"><Button type="button" variant="outline" disabled={isSaving} onClick={onClose}>Cancel</Button><Button type="submit" disabled={isSaving || !batchUid}>{isSaving ? "Saving…" : "Save Changes"}</Button></div>
      </form>
    </Modal>
  );
};
export default EditNgPartModal;
